/* @flow */
import styled from 'styled-components'
import THEME from './Spotify2.theme'
import {
  styleProvider,
  getBackgroundStyles,
  getTextStyleByAlignment
} from '@website/common/utils'
import WMContainer from '@website/common/components/WMContainer'
import Container from '@website/common/components/Container'

const getStyleForProp = styleProvider(THEME)

const WmCustomContainer = styled(WMContainer)`
  padding-top: 0;
  display: flex;
  flex-direction: column;
  > :first-child {
    margin-bottom: 0;
  }
  & > .control-container {
    width: 100%;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
  }
  & > .control-container {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    > h1 {
      max-width: unset;
      margin: 0;
    }
  }
`

const StyledContainer = styled(Container)`
  ${getBackgroundStyles(THEME)};
  flex-direction: column;
  align-items: center;
  padding: ${({ isEditing }) => (isEditing ? '100px 0 80px 0' : '80px 0')};
  @media only screen and (max-width: 1300px) {
    padding: ${({ isEditing }) => (isEditing ? '140px 0 80px 0' : '80px 0')};
  }
  @media only screen and (max-width: 457px) {
    padding: ${({ isEditing }) => (isEditing ? '120px 0 60px 0' : '60px 0')};
  }
`

const Title = styled.h1`
  color: ${getStyleForProp('heading')};
  width: 100%;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 1024px) {
    max-width: 100%;
  }
  ${getTextStyleByAlignment};
`

const MusicWrapper = styled.div`
  width: 100%;
  max-width: ${props => (props.isForBlock ? '900px' : '1200px')};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0;
  margin: -30px auto 0 auto;
  padding-top: 50px;
  @media only screen and (max-width: 992px) {
    padding-top: 40px;
  }
`

const MusicContent = styled.div`
  width: 300px;
  min-width: 300px;
  border-radius: ${getStyleForProp('badgeRadius')};
  position: relative;
  margin: 30px 15px 0 15px;
`

const IframeWrapper = styled.div`
  width: 100%;
  position: relative;
  iframe {
    width: 100%;
    height: 380px;
    border-radius: ${getStyleForProp('badgeRadius')};
    -webkit-mask-image: -webkit-radial-gradient(white, black);
  }
`

export default {
  WmCustomContainer,
  StyledContainer,
  Title,
  MusicContent,
  IframeWrapper,
  MusicWrapper
}
